import type { AffiliateReferenceConditionResponse } from '@modules/affiliate-reference/types';
import type { IContextQueryResult } from '@modules/core/services/query/types';
import {
  AFFILIATE_REFERENCE_CONDITION_API_URL,
  AFFILIATE_REFERENCE_CONDITION_QUERY_KEY,
  AFFILIATE_REFERENCE_PERMISSIONS,
} from '@modules/affiliate-reference/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

export default function useAffiliateReferenceConditionQuery():
IContextQueryResult<AffiliateReferenceConditionResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [AFFILIATE_REFERENCE_CONDITION_QUERY_KEY],
    queryFn: () => fetchGet<AffiliateReferenceConditionResponse>(
      AFFILIATE_REFERENCE_CONDITION_API_URL,
      {
        permission: AFFILIATE_REFERENCE_PERMISSIONS.SHOW,
      },
    ),
  });
}
